(function () {
  'use strict';

  function list(root, selector) {
    return Array.prototype.slice.call(root.querySelectorAll(selector));
  }

  function number(value) {
    return Number(value).toFixed(1).replace(/\.0$/, '');
  }

  function init(root) {
    if (!root || root.dataset.dmw2Ready === 'true') return;
    root.dataset.dmw2Ready = 'true';

    var config = {};
    try {
      config = JSON.parse(root.querySelector('[data-dmw2-config]').textContent);
    } catch (error) {
      config = { currency: 'USD', materials: {}, addons: {} };
    }

    var state = {
      material: 'walnut',
      length: 145,
      depth: 75,
      frame: 'black-silver',
      controller: 'lift-dpg',
      unit: 'cm',
      view: 0,
      addons: new Set()
    };

    var materialButtons = list(root, '[data-dmw2-material]');
    var frameButtons = list(root, '[data-dmw2-frame]');
    var controllerButtons = list(root, '[data-dmw2-controller]');
    var unitButtons = list(root, '[data-dmw2-unit]');
    var viewButtons = list(root, '[data-dmw2-view]');
    var addonButtons = list(root, '[data-dmw2-addon]');
    var accordionButtons = list(root, '[data-dmw2-accordion]');
    var lengthInput = root.querySelector('[data-dmw2-length]');
    var depthInput = root.querySelector('[data-dmw2-depth]');
    var lengthOutput = root.querySelector('[data-dmw2-length-output]');
    var depthOutput = root.querySelector('[data-dmw2-depth-output]');
    var previewImage = root.querySelector('[data-dmw2-preview-image]');
    var previewSize = root.querySelector('[data-dmw2-preview-size]');
    var previewMaterial = root.querySelector('[data-dmw2-preview-material]');
    var previewFrame = root.querySelector('[data-dmw2-preview-frame]');
    var previewController = root.querySelector('[data-dmw2-preview-controller]');
    var currentMaterial = root.querySelector('[data-dmw2-current="material"]');
    var currentFrame = root.querySelector('[data-dmw2-current="frame"]');
    var currentController = root.querySelector('[data-dmw2-current="controller"]');
    var sizeStatus = root.querySelector('[data-dmw2-size-status]');
    var totalOutput = root.querySelector('[data-dmw2-total]');
    var priceLabel = root.querySelector('[data-dmw2-price-label]');
    var actionStatus = root.querySelector('[data-dmw2-action-status]');
    var primaryButton = root.querySelector('[data-dmw2-primary]');
    var primaryLabel = root.querySelector('[data-dmw2-primary-label]');
    var errorOutput = root.querySelector('[data-dmw2-error]');
    var resetButton = root.querySelector('[data-dmw2-reset]');
    var quote = root.querySelector('[data-dmw2-quote]');
    var quoteClose = root.querySelector('[data-dmw2-quote-close]');
    var addonDetail = root.querySelector('[data-dmw2-addon-detail]');
    var addonDetailClose = root.querySelector('[data-dmw2-addon-detail-close]');
    var addonDetailImage = root.querySelector('[data-dmw2-addon-detail-image]');
    var addonDetailTitle = root.querySelector('[data-dmw2-addon-detail-title]');
    var addonDetailPrice = root.querySelector('[data-dmw2-addon-detail-price]');
    var addonDetailSelection = root.querySelector('[data-dmw2-addon-detail-selection]');
    var addonDetailDescription = root.querySelector('[data-dmw2-addon-detail-description]');
    var addonDetailLink = root.querySelector('[data-dmw2-addon-detail-link]');
    var addonDetailOptions = root.querySelector('[data-dmw2-addon-detail-options]');
    var addonDetailError = root.querySelector('[data-dmw2-addon-detail-error]');
    var addonDetailRemove = root.querySelector('[data-dmw2-addon-detail-remove]');
    var addonDetailConfirm = root.querySelector('[data-dmw2-addon-detail-confirm]');
    var requestBody = root.querySelector('[data-dmw2-request-body]');
    var technicalToggle = root.querySelector('[data-dmw2-technical-toggle]');
    var technical = root.querySelector('[data-dmw2-technical]');
    var review = {
      material: root.querySelector('[data-dmw2-review="material"]'),
      size: root.querySelector('[data-dmw2-review="size"]'),
      frame: root.querySelector('[data-dmw2-review="frame"]'),
      controller: root.querySelector('[data-dmw2-review="controller"]'),
      addons: root.querySelector('[data-dmw2-review="addons"]')
    };
    var activeAddonButton = null;
    var activeAddonProduct = null;
    var activeAddonVariant = null;
    var activeAddonValues = [];

    var frameLabels = {
      'white-silver': 'White + Silver',
      'black-silver': 'Black + Silver',
      'all-black': 'Black + Black'
    };

    var controllerLabels = {
      'lift-dpg': 'Paddle control',
      lift: 'Button control'
    };

    var controllerMethodLabels = {
      'lift-dpg': 'Paddle',
      lift: 'Buttons'
    };

    function materialData() {
      return config.materials && config.materials[state.material]
        ? config.materials[state.material]
        : { label: state.material, views: [], variants: [] };
    }

    function displayDimension(value) {
      if (state.unit === 'in') return number(Number(value) / 2.54) + ' in';
      return number(value) + ' cm';
    }

    function displaySize() {
      if (state.unit === 'in') {
        return number(state.length / 2.54) + ' × ' + number(state.depth / 2.54) + ' in';
      }
      return number(state.length) + ' × ' + number(state.depth) + ' cm';
    }

    function productionSize() {
      return number(state.length) + ' × ' + number(state.depth) + ' cm';
    }

    function money(cents) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
          style: 'currency',
          currency: config.currency || 'USD',
          maximumFractionDigits: 0
        }).format(Number(cents || 0) / 100);
      } catch (error) {
        return '$' + Math.round(Number(cents || 0) / 100).toLocaleString('en-US');
      }
    }

    function selectedVariant() {
      if (state.controller !== 'lift-dpg') return null;
      return (materialData().variants || []).find(function (variant) {
        return Number(variant.length) === Number(state.length)
          && Number(variant.depth) === Number(state.depth)
          && variant.frame === state.frame
          && variant.available !== false;
      }) || null;
    }

    function selectedAddons() {
      return addonButtons.filter(function (button) {
        return state.addons.has(button.dataset.dmw2Addon);
      });
    }

    function addonNames() {
      var names = selectedAddons().map(function (button) {
        var title = button.querySelector('strong');
        var name = title ? title.textContent.trim() : button.dataset.dmw2Addon;
        var selection = button.dataset.selectionLabel || '';
        if (selection && selection !== 'Default Title') name += ' — ' + selection;
        return name;
      });
      return names.length ? names : ['None selected'];
    }

    function addonProduct(handle) {
      return config.addons && config.addons[handle] ? config.addons[handle] : null;
    }

    function matchingAddonVariant(product, values) {
      return (product.variants || []).find(function (variant) {
        return variant.available !== false && variant.values.every(function (value, index) {
          return value === values[index];
        });
      }) || null;
    }

    function updateAddonDetailVariant() {
      activeAddonVariant = activeAddonProduct
        ? matchingAddonVariant(activeAddonProduct, activeAddonValues)
        : null;
      addonDetailError.hidden = Boolean(activeAddonVariant);
      addonDetailError.textContent = activeAddonVariant ? '' : 'This combination is not currently available.';
      addonDetailConfirm.disabled = !activeAddonVariant;
      addonDetailPrice.textContent = activeAddonVariant ? money(activeAddonVariant.price) : 'Unavailable';
      addonDetailSelection.textContent = activeAddonVariant && activeAddonVariant.title !== 'Default Title'
        ? activeAddonVariant.title
        : '';
      if (activeAddonVariant && activeAddonVariant.image) {
        addonDetailImage.removeAttribute('srcset');
        addonDetailImage.src = activeAddonVariant.image;
      }

      list(addonDetailOptions, '[data-dmw2-addon-option-value]').forEach(function (button) {
        var index = Number(button.dataset.dmw2AddonOptionIndex);
        var selected = activeAddonValues[index] === button.dataset.dmw2AddonOptionValue;
        button.classList.toggle('is-active', selected);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
    }

    function renderAddonOptions() {
      addonDetailOptions.innerHTML = '';
      (activeAddonProduct.options || []).forEach(function (option, optionIndex) {
        var fieldset = document.createElement('fieldset');
        var legend = document.createElement('legend');
        var values = document.createElement('div');
        legend.textContent = option.name;
        values.className = 'dmw2-addon-detail__values';

        (option.values || []).forEach(function (value) {
          var button = document.createElement('button');
          button.type = 'button';
          button.textContent = value;
          button.dataset.dmw2AddonOptionValue = value;
          button.dataset.dmw2AddonOptionIndex = String(optionIndex);
          button.setAttribute('aria-pressed', activeAddonValues[optionIndex] === value ? 'true' : 'false');
          if (activeAddonValues[optionIndex] === value) button.classList.add('is-active');
          button.addEventListener('click', function () {
            activeAddonValues[optionIndex] = value;
            updateAddonDetailVariant();
          });
          values.appendChild(button);
        });

        fieldset.appendChild(legend);
        fieldset.appendChild(values);
        addonDetailOptions.appendChild(fieldset);
      });
      updateAddonDetailVariant();
    }

    function openAddonDetail(button) {
      var product = addonProduct(button.dataset.dmw2Addon);
      if (!product) return;
      activeAddonButton = button;
      activeAddonProduct = product;
      addonDetail.dataset.addonHandle = button.dataset.dmw2Addon;
      activeAddonVariant = (product.variants || []).find(function (variant) {
        return String(variant.id) === String(button.dataset.variantId);
      }) || (product.variants || []).find(function (variant) { return variant.available !== false; }) || null;
      activeAddonValues = activeAddonVariant ? activeAddonVariant.values.slice() : [];

      var rowImage = button.querySelector('img');
      if (rowImage) {
        addonDetailImage.dataset.dmw2AddonFallbackImage = rowImage.currentSrc || rowImage.src;
        addonDetailImage.src = rowImage.currentSrc || rowImage.src;
        addonDetailImage.alt = product.title;
      }
      addonDetailTitle.textContent = product.title;
      addonDetailDescription.textContent = product.description || '';
      addonDetailDescription.hidden = !product.description;
      addonDetailLink.href = product.url || '#';
      addonDetailLink.hidden = !product.url;
      addonDetailRemove.hidden = !state.addons.has(button.dataset.dmw2Addon);
      addonDetailConfirm.textContent = state.addons.has(button.dataset.dmw2Addon)
        ? 'Update accessory'
        : 'Add to setup';
      addonDetailError.hidden = true;
      renderAddonOptions();
      addonDetail.classList.add('is-open');
      addonDetail.setAttribute('aria-hidden', 'false');
      window.setTimeout(function () { addonDetailClose.focus(); }, 300);
    }

    function closeAddonDetail() {
      addonDetail.classList.remove('is-open');
      addonDetail.setAttribute('aria-hidden', 'true');
      var focusTarget = activeAddonButton;
      activeAddonButton = null;
      activeAddonProduct = null;
      activeAddonVariant = null;
      activeAddonValues = [];
      if (focusTarget) focusTarget.focus();
    }

    function commitAddonSelection() {
      if (!activeAddonButton || !activeAddonVariant) return;
      var key = activeAddonButton.dataset.dmw2Addon;
      activeAddonButton.dataset.variantId = activeAddonVariant.id;
      activeAddonButton.dataset.price = activeAddonVariant.price;
      activeAddonButton.dataset.selectionLabel = activeAddonVariant.title || '';
      var price = activeAddonButton.querySelector('[data-dmw2-addon-price]');
      var selection = activeAddonButton.querySelector('[data-dmw2-addon-selection]');
      if (price) price.textContent = money(activeAddonVariant.price);
      if (selection) selection.textContent = activeAddonVariant.title === 'Default Title' ? '' : activeAddonVariant.title;
      var rowImage = activeAddonButton.querySelector('img');
      if (rowImage && activeAddonVariant.image) {
        rowImage.removeAttribute('srcset');
        rowImage.src = activeAddonVariant.image;
      }
      state.addons.add(key);
      activeAddonButton.setAttribute('aria-pressed', 'true');
      updateAction(selectedVariant());
      updateQuoteSummary();
      closeAddonDetail();
    }

    function removeAddonSelection() {
      if (!activeAddonButton) return;
      state.addons.delete(activeAddonButton.dataset.dmw2Addon);
      activeAddonButton.setAttribute('aria-pressed', 'false');
      updateAction(selectedVariant());
      updateQuoteSummary();
      closeAddonDetail();
    }

    function setPressed(buttons, active) {
      buttons.forEach(function (button) {
        var selected = button === active;
        button.classList.toggle('is-active', selected);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
    }

    function updateRange(input) {
      var value = Number(input.value);
      var min = Number(input.min);
      var max = Number(input.max);
      var progress = ((value - min) / (max - min)) * 100;
      input.style.setProperty('--dmw2-range-progress', progress + '%');
      input.closest('.dmw2-range').style.setProperty('--dmw2-range-progress', progress + '%');
    }

    function updateUnits() {
      lengthOutput.textContent = displayDimension(state.length);
      depthOutput.textContent = displayDimension(state.depth);
      previewSize.textContent = displaySize();
      unitButtons.forEach(function (button) {
        var active = button.dataset.dmw2Unit === state.unit;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      var lengthLimits = lengthInput.closest('.dmw2-range').querySelectorAll('small i');
      var depthLimits = depthInput.closest('.dmw2-range').querySelectorAll('small i');
      if (lengthLimits.length === 2) {
        lengthLimits[0].textContent = displayDimension(lengthInput.min);
        lengthLimits[1].textContent = displayDimension(lengthInput.max);
      }
      if (depthLimits.length === 2) {
        depthLimits[0].textContent = displayDimension(depthInput.min);
        depthLimits[1].textContent = displayDimension(depthInput.max);
      }
    }

    function updateFrames() {
      var selected = frameButtons.find(function (button) {
        return button.dataset.dmw2Frame === state.frame;
      });
      if (!selected && frameButtons.length) {
        selected = frameButtons[0];
        state.frame = selected.dataset.dmw2Frame;
      }
      setPressed(frameButtons, selected);
    }

    function updateControllers() {
      var selected = controllerButtons.find(function (button) {
        return button.dataset.dmw2Controller === state.controller;
      });
      if (!selected && controllerButtons.length) {
        selected = controllerButtons[0];
        state.controller = selected.dataset.dmw2Controller;
      }
      setPressed(controllerButtons, selected);
    }

    function previewViews(variant) {
      var views = (materialData().views || []).slice();
      if (variant && variant.image) views[0] = variant.image;
      if (state.frame === 'all-black' && variant && variant.image) {
        views = [variant.image, variant.image, variant.image];
      }
      return views;
    }

    function updatePreview(variant, preserveImage) {
      var views = previewViews(variant);
      viewButtons.forEach(function (button, index) {
        var image = button.querySelector('img');
        if (image && views[index]) {
          image.removeAttribute('srcset');
          image.src = views[index];
        }
        var active = index === state.view;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      var source = views[state.view] || views[0];
      var sourceUrl = source ? new URL(source, document.baseURI).href : '';
      if (!preserveImage && previewImage && sourceUrl && previewImage.src !== sourceUrl) {
        previewImage.classList.add('is-changing');
        previewImage.removeAttribute('srcset');
        previewImage.src = sourceUrl;
        window.setTimeout(function () { previewImage.classList.remove('is-changing'); }, 180);
      }

      var previewWidth = Math.max(95, Math.min(124, 95 + ((state.length - 100) / 100) * 35));
      if (previewImage) previewImage.style.setProperty('--dmw2-preview-width', previewWidth + '%');
      previewMaterial.textContent = materialData().label;
      previewFrame.textContent = frameLabels[state.frame] + ' columns';
      previewController.textContent = controllerLabels[state.controller];
    }

    function updateQuoteSummary() {
      review.material.textContent = materialData().label;
      review.size.textContent = productionSize();
      review.frame.textContent = frameLabels[state.frame];
      review.controller.textContent = controllerLabels[state.controller];
      review.addons.textContent = addonNames().join(', ');
      if (requestBody) {
        requestBody.value = [
          'Build Your Workspace configuration',
          '',
          'Desktop: ' + materialData().label,
          'Dimensions: ' + productionSize(),
          'Columns: ' + frameLabels[state.frame],
          'Controller: ' + controllerLabels[state.controller],
          'Add-ons: ' + addonNames().join(', '),
          'Status: Custom configuration — quotation and feasibility review required'
        ].join('\n');
      }
    }

    function updateAction() {
      priceLabel.textContent = 'Custom desk';
      totalOutput.textContent = 'Custom quote';
      actionStatus.textContent = 'Final price and lead time confirmed after configuration review';
      primaryLabel.textContent = 'Request a quote';
      sizeStatus.classList.add('is-custom');
      sizeStatus.querySelector('span').textContent = 'Custom configuration · reviewed before production';
    }

    function update(preservePreviewImage) {
      lengthInput.value = state.length;
      depthInput.value = state.depth;
      updateRange(lengthInput);
      updateRange(depthInput);
      updateUnits();
      updateFrames();
      updateControllers();

      var activeMaterial = materialButtons.find(function (button) {
        return button.dataset.dmw2Material === state.material;
      });
      setPressed(materialButtons, activeMaterial);

      currentMaterial.textContent = materialData().label;
      currentFrame.textContent = frameLabels[state.frame];
      currentController.textContent = controllerMethodLabels[state.controller];

      var variant = selectedVariant();
      updatePreview(variant, preservePreviewImage === true);
      updateAction();
      updateQuoteSummary();
      errorOutput.hidden = true;
    }

    function openQuote() {
      updateQuoteSummary();
      quote.classList.add('is-open');
      quote.setAttribute('aria-hidden', 'false');
      var focusTarget = quote.querySelector('input, textarea, button');
      if (focusTarget) window.setTimeout(function () { focusTarget.focus(); }, 300);
    }

    function closeQuote() {
      quote.classList.remove('is-open');
      quote.setAttribute('aria-hidden', 'true');
      primaryButton.focus();
    }

    materialButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        state.material = button.dataset.dmw2Material;
        state.view = 0;
        update();
      });
    });

    frameButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        state.frame = button.dataset.dmw2Frame;
        state.view = 0;
        update();
      });
    });

    controllerButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        state.controller = button.dataset.dmw2Controller;
        update();
      });
    });

    function changeDimensions() {
      state.length = Number(lengthInput.value);
      state.depth = Number(depthInput.value);
      // Dimension changes update the quote and labels, not the product photograph.
      update(true);
    }

    lengthInput.addEventListener('input', changeDimensions);
    depthInput.addEventListener('input', changeDimensions);

    function chooseUnit(button) {
      state.unit = button.dataset.dmw2Unit;
      updateUnits();
      updateQuoteSummary();
    }

    unitButtons.forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.stopPropagation();
        chooseUnit(button);
      });
      button.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          event.stopPropagation();
          chooseUnit(button);
        }
      });
    });

    viewButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        state.view = Number(button.dataset.dmw2View);
        updatePreview(selectedVariant());
      });
    });

    addonButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        openAddonDetail(button);
      });
    });

    accordionButtons.forEach(function (button) {
      button.addEventListener('click', function (event) {
        if (event.target.closest('[data-dmw2-unit]')) return;
        var option = button.closest('.dmw2-option');
        var open = !option.classList.contains('is-open');
        option.classList.toggle('is-open', open);
        button.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    technicalToggle.addEventListener('click', function () {
      var open = technical.hidden;
      technical.hidden = !open;
      technicalToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    resetButton.addEventListener('click', function () {
      state.material = 'walnut';
      state.length = 145;
      state.depth = 75;
      state.frame = 'black-silver';
      state.controller = 'lift-dpg';
      state.unit = 'cm';
      state.view = 0;
      state.addons.clear();
      addonButtons.forEach(function (button) { button.setAttribute('aria-pressed', 'false'); });
      update();
    });

    primaryButton.addEventListener('click', openQuote);

    quoteClose.addEventListener('click', closeQuote);
    addonDetailClose.addEventListener('click', closeAddonDetail);
    addonDetailConfirm.addEventListener('click', commitAddonSelection);
    addonDetailRemove.addEventListener('click', removeAddonSelection);
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && addonDetail.classList.contains('is-open')) {
        closeAddonDetail();
        return;
      }
      if (event.key === 'Escape' && quote.classList.contains('is-open')) closeQuote();
    });

    update();

    if (root.querySelector('[data-dmw2-auto-open]')) openQuote();
  }

  function boot() {
    document.querySelectorAll('[data-dmw2-builder]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target.querySelector('[data-dmw2-builder]'));
  });
})();
